<p-dialog [header]="screen.actions.uploadFile" [visible]="showDialog" (visibleChange)="showDialogChange.emit($event)"
  [draggable]="false" [resizable]="false" [modal]="true" [blockScroll]="true" [dismissableMask]="false"
  [closeOnEscape]="false" [closable]="!saving" appendTo="body"
  [style]="{ width: errors && errors.length > 0 ? '1024px' : '500px' }">
  <form class="flex flex-column" (validate)="uploadFile()" novalidate validation-es>
    <label class="col-12 px-0" for="atcUpload">
      {{screen.labels.atcFile}}
    </label>

    <div class="col-12 px-0 inline-flex align-items-center">
      <p-fileUpload #atcUploadFile mode="basic" name="atcUpload_file" accept=".xlsx,.xls"
        [chooseLabel]="screen.actions.upload" [customUpload]="true" (onSelect)="selectFile($event)"
        [customUpload]="true" (uploadHandler)="resetFileSelection()" [showUploadButton]="false"></p-fileUpload>

      <p-button type="button" icon="fas fa-trash" (onClick)="clearFile()"
        styleClass="ml-2 p-button-danger p-button-outlined" *ngIf="file"></p-button>

      <span class="ml-2 text-danger" *ngIf="errors && errors.length > 0">
        {{screen.messages.mustFixExcelIssues}}
      </span>
    </div>

    <hr *ngIf="errors && errors.length > 0">

    <p-table [value]="errors" [scrollable]="true" scrollHeight="calc(100vh - 350px)" class="col-12 px-0"
      *ngIf="errors && errors.length > 0">
      <ng-template pTemplate="header">
        <tr>
          <th scope="detail">{{screen.labels.detail}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-error>
        <tr>
          <td>{{error.detail}}</td>
        </tr>
      </ng-template>
    </p-table>

    <hr>

    <div class="align-self-end">
      <p-button type="submit" icon="far fa-save" [label]="screen.actions.send" [loading]="saving"
        styleClass="p-button-success p-button-outlined"></p-button>
    </div>

    <input name="atcUpload" hidden [readOnly]="true" [(ngModel)]="file" [required]="true" validation />
  </form>
</p-dialog>